<!--
 * @Author: 曹捷
 * @Date: 2021-05-13 09:56:05
 * @LastEditors: 曹捷
 * @LastEditTime: 2021-10-11 16:33:14
 * @Description: 扩展  封装开关操作
-->
<template>
  <a-switch :checkedChildren="check" :disabled="disabled" :unCheckedChildren="uncheck" @change="infoChange" v-model:checked="checked"></a-switch>
</template>

<script>
import { inject,reactive, getCurrentInstance, toRefs, watch } from 'vue'
import { util } from 'obit-wui'
export default {
  props: {
    value: {
      type: [Boolean, String, Number]
    },
    // switch 打开时的值
    activeValue: {
      type: [Boolean, String, Number],
      default: '1'
    },
    // switch 关闭时的值	
    inactiveValue: {
      type: [Boolean, String, Number],
      default: '0'
    },
    disabled:{
      type:Boolean,
      default:false
    },
    //开启操作名称、开始时显示内容
    check: {
      type: String,
      default: '开启',
    },
    //关闭操作名称、关闭时显示内容
    uncheck: {
      type: String,
      default: '关闭',
    },
    // Function  必须返回  promise 对象
    before:{
      type:Function
    },
    info:{
      type: Object,
      default: {
        //接口地址
        ajaxUrl: '',
        //操作字段名
        fieldName: '',
        //请求方式
        ajaxType: 'post',
      },
    }
  },
  setup (props, context) {
    let http = inject('http')
    let { proxy } = getCurrentInstance()
    let _data = reactive({
      checked: props.value == props.activeValue
    })

    let methods = {
      sysnValueToChecked () {
        if (props.value === props.activeValue) {
          _data.checked = true
        } else if (props.value === props.inactiveValue) {
          _data.checked = false
        }
      },
      infoChange (value) {
        if(props.before){
          if(props.before instanceof Function){
            methods.changeContinue(props.before)  
          }else{
            throw new Error(`参数错误，before 必须是Function,且返回promise对象`)
          }
        }else{
          methods.changeContinue(function(){
            return new Promise((resolve,reject)=>{
              let contents = `请确认是否${_data.checked ? props.check : props.uncheck}`
              let param = util.util.cloneObj(props.info.data ?props.info.data:{})
              param[props.info.fieldName] = value ? props.activeValue :props.inactiveValue
              proxy.$confirm({
                title: '提示',
                content: contents,
                onOk () {
                  http.getDataByUrl(`${props.info.ajaxUrl}`, param, props.info.ajaxType).then((res) => {
                    resolve()
                    proxy.$message.success('操作成功')
                  }).catch(err=>{
                    reject()
                  })
                },
                onCancel () {
                  reject()
                }
              })
            })
          })
        }
      },
      /**
       * 前置拦截 成功 或者失败
       */
      changeContinue(hasNext){
        hasNext().then(res=>{
          context.emit('reload')
          context.emit('update:value',_data.checked)
        }).catch(err=>{
          _data.checked =!_data.checked
        })
      }
    }
    watch(() => _data.checked, (value, oldvalue) => {
      if (oldvalue !== value) {
        context.emit('update:value', value ? props.activeValue : props.inactiveValue)
        context.emit("changed", value ? props.activeValue : props.inactiveValue)
      }
    })
    watch(() => props.value, (value, oldvalue) => {
      if (oldvalue !== value) {
        methods.sysnValueToChecked()
      }
    })
    return {
      ...toRefs(_data),
      ...methods
    }
  }
}
</script>

<style>
</style>
